import { WATERMARK } from "constants/chartCommons";
import { selectedLegendItems } from "../chart.functions";

export const getOptions = (series: Highcharts.SeriesOptionsType[], legendSelected: number[]): Highcharts.Options => {
    return {
        chart: {
            animation: false,
            className: "SituationalChart",
            polar: true,
            type: "line",
            spacing: [0, 0, 0, 0],
            margin: [0, 0, 0, 0],
        },
        credits: {
            text: WATERMARK,
            href: "#",
            position: {
                align: "left",
            },
            style: {
                fontSize: "8px",
            },
        },
        title: {
            text: undefined,
        },
        xAxis: {
            gridLineWidth: 0,
            labels: {
                distance: 8,
                useHTML: true,
                style: {
                    fontSize: "10px",
                    color: "#84acbc",
                    whiteSpace: "inherit",
                },
                formatter: function () {
                    if (this.pos === 0) {
                        return `<span style="width: 120px; display: inline-block; text-align: center; white-space: inherit; margin-top: -12px;">${this.value}</span>`;
                    }
                    if (this.pos === 1) {
                        return `<span style="width: 90px; text-align: left; white-space: break-spaces;">${this.value}</span>`;
                    }
                    if (this.pos === 2) {
                        return `<span style="width: 100px; display: inline-block; text-align: center;">${this.value}</span>`;
                    }
                    if (this.pos === 3) {
                        return `<span style="width: 62px; display: inline-block; text-align: right; padding-right: 10px;">${this.value}</span>`;
                    }
                    return `${this.value}`;
                },
            },
            tickmarkPlacement: "on",
            lineWidth: 0,
        },
        yAxis: {
            gridLineInterpolation: "polygon",
            gridLineColor: "#84acbc",
            tickInterval: 10,
            labels: {
                useHTML: true,
                style: {
                    backgroundColor: "#fff",
                    color: "#84acbc",
                },
            },
        },
        tooltip: {
            enabled: true,
            pointFormat: "",
            padding: 0,
            backgroundColor: "#000000",
            borderWidth: 0,
            shared: false,
            useHTML: true,
            style: {
                color: "white",
                fontSize: "11px",
            },
        },
        legend: {
            verticalAlign: "bottom",
            itemWidth: 120,
            margin: 20,
        },
        plotOptions: {
            series: {
                // animation: false,
                marker: {
                    enabled: false,
                },
                enableMouseTracking: true,
                events: {
                    legendItemClick: function (this: Highcharts.Series) {
                        selectedLegendItems(this, legendSelected);
                    },
                },
            },
        },
        series,
        exporting: {
            menuItemDefinitions: {
                downloadPNG: { text: "Download PNG Image" },
                downloadSVG: { text: "Download SVG Image" },
            },
            buttons: {
                contextButton: {
                    menuItems: ["downloadPNG", "downloadSVG"],
                },
            },
            allowHTML: true,
            chartOptions: {
                pane: {
                    size: "80%",
                },
            },
        },
    };
};
